export const childCacheGroup = ['snapsnap-api-get-group-children', 'snapsnap-api-get-group-child', 'snapsnap-api-event-uchinoko-search']

export const groupCacheGroup = ['snapsnap-api-get-groups']

export const groupSettingsGroup = ['snapsnap-api-get-group-setting']

export const eventCacheGroup = ['snapsnap-api-get-event', 'snapsnap-api-get-event-albums', 'snapsnap-api-event-uchinoko-search']
